import React, { useEffect } from 'react';
import UrlParse from 'url-parse';
import { Layout } from 'antd';
import ApplicationBasicPage from './ApplicationBasicPage';

const { Content } = Layout;

const ApplicationDetailPage = props => {
	useEffect(() => {
		getApplicationById();
		return () => props.resetPage();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getApplicationById = () => {
		const { location } = props;
		const { query } = UrlParse(location.search, true);
		if (query && query.id) {
			props.getApplicationById(query.id);
		} else {
			props.history.push('/applications');
		}
	};

	const getApplicationComponent = () => {
		const path = props.location.pathname.split('/');
		const pathname = path[path.length - 1];

		switch (true) {
			case pathname === 'basic':
				return <ApplicationBasicPage {...props} />;
			default:
				props.history.push('/applications');
		}
	};

	return (
		<React.Fragment>
			<Content style={{ margin: 0 }}>{getApplicationComponent()}</Content>
		</React.Fragment>
	);
};

export default ApplicationDetailPage;
